import './App.css';

import Router from './_common/Router';

function App() {
  return (
    <Router />
  );
}

export default App;
